<aside class="user-info-wrapper">
  <div class="user-cover" style="background-image: url(assets/img/account/user-cover-img.jpg);">
  </div>
  <div class="user-info">
    <div class="user-avatar">
      <a class="edit-avatar" href="javascript:void(0);" file-upload>
        <i class="material-icons edit"></i>Edit</a>
      <img *ngIf="user.profilePhoto" src="{{user?.profilePhoto}}" alt="User">
      <img *ngIf="!user.profilePhoto" src="assets/img/download.png" alt="User">
    </div>
    <div class="user-data">
      <h5>{{user?.userName}}</h5>
      <span>{{user?.email}}</span>
    </div>
  </div>
</aside>
<nav class="list-group">
  <a class="list-group-item" href="javascript:void(0);" routerLinkActive="active" routerLink="/app/profile-view">
    <i class="icon-head"></i>Profile</a>
  <a class="list-group-item" href="javascript:void(0);" routerLinkActive="active" routerLink="/app/address">
    <i class="material-icons  contacts"></i>Addresses</a>
  <a class="list-group-item with-badge" href="javascript:void(0);" routerLinkActive="active" routerLink="/app/temple-profile"
    *ngIf="templeOwner">
    <i class="material-icons home"></i>{{'Temple'|translate}} Profile
  </a>
  <a class="list-group-item with-badge" href="javascript:void(0);" routerLinkActive="active" routerLink="/app/temple-address"
    *ngIf="templeOwner">
    <i class="material-icons  contacts"></i>{{'Temple'|translate}} {{'Address'|translate}}
  </a>
  <a class="list-group-item" routerLinkActive="active" href="javascript:void(0);" routerLink="/app/wish-list">
    <i class="icon-heart"></i>WishList</a>
  <a class="list-group-item" href="javascript:void(0);" routerLinkActive="active" routerLink="/app/devotee/payment/transactions">
    <i class="material-icons credit_card"></i>Transactions</a>
  <a *ngIf="isAccount" class="list-group-item with-badge" href="javascript:void(0);" (click)="signOut()">
    <i class="icon-lock"></i>Log Out
  </a>
</nav>